import React from "react";

const SecurityPage = () => {
  return (
    <div>
      <h3 className="fw-bold">Security</h3>
      <p className="text-muted">Manage password, login history, and 2FA.</p>

      <div className="card p-2 shadow-sm mt-3">
        <h5>Change Password</h5>

        <input
          className="form-control mt-3"
          placeholder="Current Password"
          type="password"
        />
        <input
          className="form-control mt-3"
          placeholder="New Password"
          type="password"
        />

        <button className="btn btn-success mt-3">Update Password</button>
      </div>

      <div className="card p-2 shadow-sm mt-4">
        <h5>Recent Login Activity</h5>
        <p>No suspicious activity detected.</p>
      </div>
    </div>
  );
};

export default SecurityPage;
